(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getFeedId(mount) {
    const configured = mount.getAttribute('data-feed-id');
    if (configured !== null && configured !== '') {
      const parsed = parseInt(configured, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    }

    const feedEl = mount.querySelector('[id^="feed-"]');
    if (feedEl) {
      const match = feedEl.id.match(/^feed-(\d+)$/);
      if (match) return parseInt(match[1], 10);
    }

    return 0;
  }

  function hasSlider(mount, feedId) {
    const prefix = feedId === 0 ? 'instafeed' : 'feed-' + feedId;
    return Boolean(
      mount.querySelector('.' + prefix + '-new-arrow-next') ||
        mount.querySelector('.' + prefix + '-new-layout-container') ||
        mount.querySelector('.instafeed-carousel-arrow')
    );
  }

  function startAutoplay(mount) {
    if (prefersReducedMotion()) return;
    if (mount.dataset.autoplayStarted === 'true') return;
    if (typeof window.instafeedSliderMove !== 'function') return;

    const feedId = getFeedId(mount);
    if (!hasSlider(mount, feedId)) return;

    const intervals = window.instafeedScrollIntervals || {};
    if (intervals[feedId]) return;

    const speed = parseInt(mount.getAttribute('data-autoplay-speed') || '5000', 10);
    mount.dataset.autoplayStarted = 'true';

    let timer = null;

    const tick = function () {
      if (typeof window.instafeedSliderMove === 'function') {
        window.instafeedSliderMove(1, feedId);
      }
    };

    const start = function () {
      if (timer) window.clearInterval(timer);
      timer = window.setInterval(tick, speed);
    };

    const stop = function () {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    start();
    mount.addEventListener('mouseenter', stop);
    mount.addEventListener('mouseleave', start);
    mount.addEventListener('focusin', stop);
    mount.addEventListener('focusout', start);
    mount.addEventListener('touchstart', stop, { passive: true });
  }

  function initMount(mount) {
    if (!mount || mount.dataset.autoplayObserved === 'true') return;
    mount.dataset.autoplayObserved = 'true';
    startAutoplay(mount);
  }

  function initVisible() {
    document.querySelectorAll('.instagram-feed__instafeed-mount[data-autoplay-enabled="true"]').forEach(function (mount) {
      initMount(mount);
    });
  }

  function observeMounts() {
    if (!('IntersectionObserver' in window)) {
      initVisible();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            initMount(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    document.querySelectorAll('.instagram-feed__instafeed-mount[data-autoplay-enabled="true"]').forEach(function (mount) {
      observer.observe(mount);
    });
  }

  function scheduleInit() {
    var run = function () {
      observeMounts();
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      window.setTimeout(run, 800);
    }
  }

  document.addEventListener('instafeedAppLoaded', scheduleInit);

  if (document.readyState === 'complete') {
    scheduleInit();
  } else {
    window.addEventListener('load', scheduleInit, { once: true });
  }
})();
